import { useIsMutating } from '@/api/hooks';
import { Checkbox, Modal, type ModalProps, Space, Text } from '@/components';
import { type FC, type ReactNode, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = ModalProps & {
  disclaimerText: ReactNode;
  skipCheck?: boolean;
};

export const ConfirmModal: FC<Props> = ({
  okButtonProps,
  cancelButtonProps,
  disclaimerText,
  onOk,
  onCancel,
  skipCheck,
  ...props
}) => {
  const [checked, setChecked] = useState(false);
  const { t } = useTranslation();
  const mutationCount = useIsMutating();

  useEffect(() => {
    if (props.open === false) {
      setChecked(false);
    }
  }, [props.open]);

  return (
    <Modal
      {...props}
      okButtonProps={{
        ...okButtonProps,
        disabled:
          !!okButtonProps?.disabled ||
          mutationCount > 0 ||
          (!checked && !skipCheck),
      }}
      onOk={onOk}
      cancelButtonProps={{
        ...cancelButtonProps,
        disabled: !!cancelButtonProps?.disabled || mutationCount > 0,
      }}
      onCancel={onCancel}
      cancelText={t('cancel')}
    >
      <Space direction="vertical">
        {typeof disclaimerText === 'string' ? (
          <Text text={disclaimerText} />
        ) : (
          disclaimerText
        )}
        {!skipCheck && (
          <Checkbox
            checked={checked}
            onChange={(event) => {
              setChecked(event.target.checked);
            }}
          >
            {t('confirmed')}
          </Checkbox>
        )}
      </Space>
    </Modal>
  );
};
